import React, { ReactElement } from 'react';
import ReactStars from 'react-rating-stars-component';

import { Col, Divider, Form, Layout, Row, TypographyText } from '@components/atoms';
import InputField from '@components/molecules/InputField';
import { REVIEW_COMMENT, REVIEW_PLACE_HOLDER, REVIEW_TITLE } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';

function MainSymptom(): ReactElement {
  const { form, formData, formFieldsError, validationChecker, setFormData } = useReduxForm('survey');
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{REVIEW_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={4} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{REVIEW_COMMENT}</TypographyText>
        </Col>
      </Row>
      <Divider margin={9} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <ReactStars
            a11y={false}
            activeColor="#FFCE21"
            color="#D9D9D9"
            count={5}
            emptyIcon={<i className="far fa-star" />}
            onChange={(newRating: number) => setFormData('reviewRating', newRating)}
            size={42}
          />
        </Col>
      </Row>
      <Divider margin={7} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{ width: '100%' }} yzTypeCol="center">
          <Form
            form={form}
            initialValues={{ reviewComment: formData?.reviewComment ?? '' }}
            labelAlign="left"
            style={{ width: '100%' }}
          >
            <InputField
              borderTop={false}
              componentArray={[
                {
                  type: 'textArea',
                  yzTypeTextArea: 'surveyItem',
                  placeholder: REVIEW_PLACE_HOLDER,
                  dataIndex: 'reviewComment',
                  formData,
                  onChange: (e: any) => {
                    setFormData('reviewComment', e);
                  },
                },
              ]}
              formFieldsError={formFieldsError}
              validation={validationChecker}
            />
          </Form>
        </Col>
      </Row>
      <Divider margin={38} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
    </Layout>
  );
}

export default MainSymptom;
